import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { useCallback, useState } from 'react';

import { NumberHelper } from 'core/helpers';
import { PurchaseOrders } from 'parts/components/PartDetails/Inventory/PurchaseOrders';
import { SalesOrders } from 'parts/components/PartDetails/Inventory/SalesOrders';
import { IPurchaseOrderDetail, ISalesOrderDetail } from 'parts/types';

type IConfig =
  | { dataField: 'soAllocated' | 'soBackorder'; tableId: string; title: string }
  | { dataField: 'poData' };

interface IProps extends ICellRendererParams {
  config?: IConfig;
  isAlternateVersionEnabled?: boolean;
}

export const InventoryQuantityCell = ({
  config,
  isAlternateVersionEnabled = false,
  data,
  value,
}: IProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const onOpen = useCallback(() => setIsDrawerOpen(true), []);
  const onClose = useCallback(() => setIsDrawerOpen(false), []);

  const formattedValue = NumberHelper.format({ amount: value });

  if (!data) {
    return formattedValue;
  }

  if (!config || !isAlternateVersionEnabled) {
    return formattedValue;
  }

  const detailRecords = data[config.dataField] ?? [];

  const renderDetails = () => {
    switch (config.dataField) {
      case 'poData':
        return (
          <PurchaseOrders
            records={detailRecords as IPurchaseOrderDetail[]}
            onClose={onClose}
            isOpen={isDrawerOpen}
          />
        );
      case 'soAllocated':
      case 'soBackorder':
        return (
          <SalesOrders
            records={detailRecords as ISalesOrderDetail[]}
            tableId={config.tableId}
            title={config.title}
            onClose={onClose}
            isOpen={isDrawerOpen}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Link onClick={onOpen}>{formattedValue}</Link>
      {renderDetails()}
    </>
  );
};
